



























import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, CheckerPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import LineStyleEditor from "../../../drawing/LineStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import MultiCheckEditor from "./MultiCheckEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    lineStyleEditor: LineStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
    multiCheckEditor: MultiCheckEditor,
    quotationEditor: QuotationEditor,
  },
})
export default class CircleSelectPropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, CheckerPropertyEditableMixin) {
}
